import { render, staticRenderFns } from "./userDetailModal.vue?vue&type=template&id=2a7e6d54&scoped=true"
import script from "./userDetailModal.vue?vue&type=script&lang=js"
export * from "./userDetailModal.vue?vue&type=script&lang=js"
import style0 from "./userDetailModal.vue?vue&type=style&index=0&id=2a7e6d54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7e6d54",
  null
  
)

export default component.exports